<h3-tool-mode
  [buttons]="buttons"
  [tool]="tool"
  eventBucket="adjustment"
  [ngModel]="tool.getMeasureMode()"
  (ngModelChange)="tool.setMeasureMode($event)"
></h3-tool-mode>
